import { IconButton, styled } from "@mui/material";

export const IconButtonOutlined = styled(IconButton)({
  border: "1px solid #E5E7EB",
  borderRadius: "8px",
  height: "36px",
  width: "36px",
  color: "#6B7280",
});
